import { Typeahead } from "react-bootstrap-typeahead";
import { Card, CardBody, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BloodHoundHeading } from "../../../../Constant";
import { BLOODHOUND, STATE_OF_USA } from "../../../../Data/FormWidgets";

const BloodHound = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={BloodHoundHeading} span={BLOODHOUND} />
        <CardBody>
          <div id="bloodhound">
            <Form className="theme-form">
              <div>
                <Typeahead options={STATE_OF_USA} placeholder="States of USA" id="BloodHound" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BloodHound;
